import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';
import {
  FETCH_HOME_INSIGHTS_ELECTORIAL,
  FETCH_HOME_INSIGHTS_ELECTORIAL_ERROR,
  SET_HOME_INSIGHTS_ELECTORIAL,
} from '../../constants';

const homeInsightsElectorial = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_HOME_INSIGHTS_ELECTORIAL),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/home/electoral-profile?${
          organisationTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_HOME_INSIGHTS_ELECTORIAL,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_HOME_INSIGHTS_ELECTORIAL_ERROR,
            error,
          })
        )
      )
    )
  );

export default homeInsightsElectorial;
